import JsTimeAgo from "javascript-time-ago"
import en from "javascript-time-ago/locale/en.json"
JsTimeAgo.addDefaultLocale(en)

import ReactTimeAgo from "react-time-ago"

export default function TimeAgo(props: any) {
  return <ReactTimeAgo {...props} />
}
